import { disableFragmentWarnings, useApolloClient } from '@apollo/client';
import DataProviderClient from './react/DataProvider.client';
import DataProviderServer from './react/DataProvider.server';
import { DataProvider } from './react';
import * as shapes from './shapes';
import QueryContext from './react/QueryContext';
import { QueryProvider } from './react/QueryProvider';
import { hoist } from './react/dataModel/hoist';

export * from './react/dataModel/proptypes/index';
export * from './react/dataModel/useDataModel';
export * from './react/dataModel/useLazyDataModel';
export * from './react/dataModel/extend';
export * from './react/dataModel/useQueryAttributes';
export * from './react/dataModel/cache-util';
export * from './hoc/withQueryProvider';

disableFragmentWarnings();

export {
  DataProviderClient,
  DataProviderServer,
  DataProvider,
  shapes,
  QueryProvider,
  QueryContext,
  hoist,
  useApolloClient,
};
